import { render } from "./row-info.vue?vue&type=template&id=52c75d39"
import script from "./row-info.vue?vue&type=script&lang=js"
export * from "./row-info.vue?vue&type=script&lang=js"

import "./row-info.vue?vue&type=style&index=0&id=52c75d39&lang=scss"

import exportComponent from "/Users/a/Documents/work/new/prnew/lk-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__